import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Paper from '@material-ui/core/Paper'
import { fade, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
// import AddCustomerPaymentMethods from './AddCustomerPaymentMethods'
// import AddCustomerEcheck from './AddCustomerEcheck'
import ServiceDetailList from './ServiceDetailList'
import InvoiceOptionsModal from './InvoiceOptionsModal'
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, CircularProgress }  from '@material-ui/core';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
// import DialogContentText from '@material-ui/core/DialogContentText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import JobPicker from './JobPicker'
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
// import styles from './customer.module.scss'

const useStyles = makeStyles(theme => ({
  root: {
    width: '80%',
    margin: '20px'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  grid: {
    margin: '10px',
    padding: '10px',
    width: '95%'
  },
  gridParent: {
    margin: '10px',
    padding: '10px',
    width: '95%',
    border: '3px solid #aaa',
    borderRadius: '20px'
  },
  gridItem: {
    padding: '5px'
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paymentProfiles: {
    border: '1px solid',
    // marginRight: '5px',
    // padding: '5px'
  },
  bigText: {
    fontSize: '1.5em',
    color: '#333',
    textAlign: 'center'
  },
  paddedStuff: {
    padding: '5px',
    margin: '5px'
  }
}));

const ModifyDepositModal = (props) => {
  // console.log('ModifyDepositModal  Props: ', props)
  const classes = useStyles();

  const [open, setOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  // const [paymentTypes, setPaymentTypes] = React.useState([{ text: '', value: ''}])
 
  // const [invoice, setInvoice] = React.useState(null)
  const [state, setState] = React.useState({
    date: new Date(),
    amount: 0,
    notes: '',
    checkNumber: '',
    paymentTypes: [
      {
        text: 'Cash Collected',
        value: '1'
      },
      {
        text: 'Paper Check Received',
        value: '2'
      }
    ],
    paymentType: {text: '', value: ''},
    showCheckNumber: 'none',
    howToApply: 'Manually',
    showJobPicker: false,
    saved: false,
    showJobPicker: false,
    deposit: {},
    jobs: []
  })

  // let paymentProfiles = props.paymentProfiles
  // if (paymentProfiles && paymentProfiles.length > 0) {
  //   // console.log('Add our payment profiles!!!')
  //   let profiles = []
  //   paymentProfiles.map(pp => {
  //     let obj = {}
  //     if (pp.payment.creditCard) {
  //       obj.Text = 'Charge ' + pp.payment.creditCard.cardType + ' ' + pp.payment.creditCard.cardNumber
  //       obj.value = '3'
  //       obj.id = pp.customerPaymentProfileId
  //     } else {
  //       obj.Text = 'Charge ' + pp.payment.bankAccount.bankName + ' ' + pp.payment.bankAccount.accountNumber
  //       obj.value = '4'
  //       obj.id = pp.customerPaymentProfileId
  //     }
  //     profiles.push(obj)
  //   })
  //   profiles.push({ Text: ' -------- Offline Collection -----------  '})
  //   let newArr = profiles.concat(paymentTypes)
  //   // console.log('NEW PAYMENT TYPES:: ', newArr)
  //   // console.log('Payment Options', newArr)
  //   setPaymentTypes(newArr)

  React.useEffect(() => {
    // console.log('Modify Deposit', props)
    setState({...state, deposit: props.deposit, jobs: props.jobs})
  }, [props])

const handleClose = () => {
  // console.log('Closing DepositModal Modal')
  // props.closeModal()
  props.updateParent('Close')
}

const handleSave = () => {
  setLoading(true)
  // console.log('Save this Deposit!!!', state)
    // console.log('Send this Deposit to The Server')
    let obj = {
      client: props.client,
      data: state,
      user: props.user
    }
    axios({
      method: 'post',
      url:  `${props.url}/api/payment/acceptDeposit`,
      data: obj
    }).then(response => {
      setLoading(false)
      // console.log('Axios response from acceptDeposit: ', response)
      if (response && response.data && response.data.deposit) {
        // console.log('We have a DepositAccepted issued!!', response.data)
        props.notification({
          type: 'success',
          title: 'Deposit Accepted!',
          message: 'Deposit Was Created Successfully'
        })
        // handleClose('success', response.data)
        if (state.howToApply === 'Job') {
          setState({...state, saved: true, deposit: response.data.deposit, showJobPicker: true})
        } else {
          props.updateParent(response.data)
        }
      } else {
        props.notification({
          type: 'warning',
          title: 'Unknown Error',
          message: 'Error Generating Deposit'
        })
      }
  }).catch(e => {
    console.log('Error Saving deposit', e)
  })
}

const updatePaymentType = (a, b) => {
  // console.log('Update payment TYPE!: ', b)
  // console.log(a)
  if (b.value === '2') {
    setState({...state, showCheckNumber: 'inline', paymentType: b})
  } else {
    setState({...state, showCheckNumber: 'none', paymentType: b})
  }
}
const updateFromJobPicker = (type, d, jobs) => {
  // console.log('Upate from job picker; ', type)
  // console.log(d)
  if (d && d._id && jobs && jobs.length) {
    setState({...state, jobs: jobs, deposit: d})
  } else if (d && d._id) {
    setState({...state, deposit: d})
  }
}

function currencyFormat(num) {
  if (!num) num = 0
  return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
return (
  <div className={classes.root}>
    <Dialog open={props.open} fullWidth={false} onClose={handleClose} maxWidth='sm' aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Modify/Apply Deposit</DialogTitle>
        <DialogContent >

          <Grid container>
            <Grid item xs={6} lg={6}>
            <DialogContentText>
              Deposit Amount: {currencyFormat(state.deposit.amount)}
          </DialogContentText>

            </Grid>
            <Grid item xs={6} lg={6}>
            <DialogContentText>
            Deposit Balance: {currencyFormat(state.deposit.balance)}
          </DialogContentText>

            </Grid>
            <Grid item xs={12} lg={12}>
            <DialogContentText>
             {props.deposit.notes}
          </DialogContentText>

            </Grid>
          <Grid item lg={12}>
            { (props.deposit.howToApply === 'Job' || props.deposit.howToApply === 'Manually') ? <JobPicker jobs={state.jobs} deposit={state.deposit} client={props.client} updateParent={updateFromJobPicker} /> : '' }
          </Grid>
          </Grid>
          
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => setState({...state, editJobName: false})} color="primary">
            Cancel
          </Button> */}
          <Button color="primary" disabled={loading || state.saved || state.showJobPicker || !state.notes || !state.amount} onClick={handleSave}>
            {
              loading ? <CircularProgress /> : 'Save'
            }
          </Button>
        </DialogActions>
      </Dialog>
  </div>
  )
  }


  const mapStateToProps = (state) => {
    return {
      url: state.url,
      user: state.user,
      notification: state.notification
    }
  }
  
  export default React.memo(connect(mapStateToProps)(ModifyDepositModal))